<template>
	<app tabbar>
		<scroll-list ref="list">
			<template v-slot="{data}">
				<scroll-item>
					<div class="flex-between-center">
						<div class="code">编号：{{data.code}}</div>
						<div class="info"><span :style="{'color': contractState[data.qs_state].color}">{{contractState[data.qs_state].name}}</span></div>
					</div>
					<div class="name">{{data.project_name}}</div>
					<div class="info">甲方单位：{{data.yzdw_name}}</div>
					<div class="info">签约截止日：{{data.qy_last_date}}</div>
					<button-group slot="button">
						<c-button v-if="data.qs_state == 2 && power('7')" @click="navigateTo('/contract_detail', {id: data.id})">签署合同</c-button>
						<c-button v-else color="gray" hollow @click="navigateTo('/contract_detail', {id: data.id})">查看详情</c-button>
					</button-group>
				</scroll-item>
			</template>
		</scroll-list>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		computed: {
			...mapGetters(['power', 'contractState'])
		},
		
		mounted() {
			this.updateList();
		},
		
		methods: {
			updateList() {
				this.$refs.list.load({
					url: '/project/ht/list'
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
